import { render, staticRenderFns } from "./OrdersMain.vue?vue&type=template&id=bda7ae38&scoped=true&"
import script from "./OrdersMain.vue?vue&type=script&lang=js&"
export * from "./OrdersMain.vue?vue&type=script&lang=js&"
import style0 from "./OrdersMain.vue?vue&type=style&index=0&id=bda7ae38&scoped=true&lang=css&"
import style1 from "./OrdersMain.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda7ae38",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VContainer,VTab,VTabItem,VTabs,VTabsItems})
